<template>
  <section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-radio-group v-model="tableData.chooseRadio">
          <el-table
            v-loading="tableData.loading"
            ref="multipleTable"
            :data="tableData.data"
            tooltip-effect="dark"
            @select="handleSelectionChange"
            @select-all="handleSelectionChange"
          >
            <!-- 选择框 -->
            <el-table-column v-if="!isRadio" type="selection" width="55" />
            <!-- 选择框 end -->
            <el-table-column v-if="isRadio" width="55" label="选择">
                <template slot-scope="scope">
                  <el-radio :label="scope.row[tableData.selectTar]">&nbsp;</el-radio>
                </template>
              </el-table-column>
            <!-- 常规列表项 -->
            <el-table-column
              v-for="(item, index, key) in tableData.title"
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
            />
          </el-table>
        </el-radio-group>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </section>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import {
  etcMatchOrderList,
} from 'api/service';
export default {
  mixins: [
    tableMixin,
  ],
  props: {
    isRadio: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectTar: 'orderId',
        chooseRadio: '', // 单选选择
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'orderId',
            label: '订单编号',
          },
          {
            prop: 'customName',
            label: '客户',
          },
          {
            prop: 'sourceName',
            label: '线路',
          },
          {
            prop: 'targetDependTime',
            label: '发车时间',
          },
          {
            prop: 'carArriveDate',
            label: '到达时间',
          },
          {
            prop: 'pontageActualDouble',
            label: '已匹配金额',
          },
          {
            prop: 'pontageDouble',
            label: '预估的ETC金额',
          },
          {
            prop: 'differenceDouble',
            label: '差额',
          },
          {
            prop: 'paymentWayName',
            label: '成本模式',
          },
          {
            prop: 'vehicleClassName',
            label: '车辆种类',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: etcMatchOrderList,
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
.tableBox{
  width: 100%;
  overflow-x: auto;
}
</style>
